import { useState } from 'react'

import { useLocalNotifications } from '~/@mid_ui/local-notifications/useLocalNotifications'
import { useUser } from '~/@biz_account/useUser/useUser'
import { usePhoneVerification } from '../usePhoneVerification'
import { PhoneVerificationDialog } from './PhoneVerificationDialog'

type Props = {
  children(
    handleSubmitForm: (props: {
      number: string
      gdpr?: boolean
      marketing?: boolean
    }) => void,
    isPending: boolean,
    error?: string
  ): React.ReactNode
  handleSetCompanyCompletionShown: () => void
}

function PhoneVerification({
  children,
  handleSetCompanyCompletionShown,
}: Props) {
  const { setNotification } = useLocalNotifications()
  useState(false)
  const { user, reloadUser } = useUser()
  const {
    isDialogOpen,
    handleCloseDialog,
    isRequestingVerifyPhoneNumberStart,
    isRequestingVerifyPhoneNumberVerify,
    verifyPhoneNumberStart,
    setGdpr,
    setMarketing,
    verifiedPhoneNumber,
    twoFaCodeExpiresAt,

    verifyPhoneNumberVerify,
    verifyPhoneNumberReset,
    verifyPhoneNumberStartError,
    verifyPhoneNumberVerifyError,
  } = usePhoneVerification()

  function handlePhoneNumberVerified() {
    handleCloseDialog()

    if (user?.profile?.isCompany) {
      handleSetCompanyCompletionShown()
      return
    }
    reloadUser()
  }

  return (
    <>
      {children(
        (props) => {
          if (props.gdpr) setGdpr(props.gdpr)
          if (props.marketing) setMarketing(props.marketing)
          verifyPhoneNumberStart({ number: props.number })
        },
        isRequestingVerifyPhoneNumberStart,
        verifyPhoneNumberStartError
      )}

      {isDialogOpen && (
        <PhoneVerificationDialog
          verifiedPhoneNumber={verifiedPhoneNumber}
          twoFaCodeExpiresAt={twoFaCodeExpiresAt}
          handleCloseDialog={handleCloseDialog}
          resendPhoneVerificationCode={
            verifiedPhoneNumber
              ? async () => {
                  await verifyPhoneNumberStart({
                    number: verifiedPhoneNumber,
                  })
                  setNotification(
                    'success',
                    'Opätovné zaslanie SMS prebehlo úspešne.'
                  )
                  verifyPhoneNumberReset()
                }
              : undefined
          }
          handleVerifyPhoneNumberVerify={(props) =>
            verifyPhoneNumberVerify(props, {
              onSuccess: handlePhoneNumberVerified,
            })
          }
          isRequestingVerifyPhoneNumberVerify={
            isRequestingVerifyPhoneNumberVerify
          }
          verifyPhoneNumberVerifyError={verifyPhoneNumberVerifyError}
        />
      )}
    </>
  )
}

export { PhoneVerification }
